import useGetInternalWidgetConfig, {
  UseGetWidgetConfigBody,
} from '@hooks/api/queries/widgets/useGetInternalWidgetConfig';
import useGetWidgetConfig from '@hooks/api/queries/widgets/useGetWidgetConfig';
import { WidgetInternalId } from '@src/types/devices/Widget.types';
import { WidgetConfig } from '@src/types/Widget';

interface UseDeviceWidgetConfigParams {
  internalId?: WidgetInternalId;
  id?: string;
  body?: UseGetWidgetConfigBody;
  enabled?: boolean;
  queryKeys?: string[];
}

const useDeviceWidgetConfig = <T extends WidgetConfig>({
  internalId,
  id,
  body,
  enabled = true,
  queryKeys,
}: UseDeviceWidgetConfigParams) => {
  const internalResult = useGetInternalWidgetConfig<T>(internalId || '', body, {
    enabled: enabled && !!internalId,
    queryKeys,
  });

  const commonResult = useGetWidgetConfig<T>(id || '', {
    enabled: enabled && !!id && !internalId,
    queryKeys,
  });

  return internalId ? internalResult : commonResult;
};

export default useDeviceWidgetConfig;
